import React from 'react';

const EditableContext = React.createContext();

export default EditableContext;
